import gql from 'graphql-tag';

const ADD_TECHGROUP = gql`
  mutation(
    $name: String
    $description: String
    $associateUsers: [UserIdentifierInput!]
    $associateClients: [OrganizationIdentifierInput!]
    $associateSites: [SiteIdentifierInput!]
    $techAutoAssignmentMethod: String
    $accessAllClients: Boolean
    $accessAllSites: Boolean
  ) {
    addTechnicianGroup(
      input: {
        name: $name
        description: $description
        associateUsers: $associateUsers
        associateClients: $associateClients
        techAutoAssignmentMethod: $techAutoAssignmentMethod
        accessAllClients: $accessAllClients
        accessAllSites: $accessAllSites
        associateSites: $associateSites
      }
    ) {
      groupId
      name
      description
      userList {
        userId
        firstName
        lastName
        email
      }
      clientList {
        accountId
        name
      }
      techAutoAssignmentMethod
      accessAllClients
    }
  }
`;

const DELETE_TECHGROUP = gql`
  mutation($groupId: ID!) {
    deleteTechGroup(groupId: $groupId)
  }
`;

const UPDATE_TECHGROUP = gql`
  mutation(
    $groupId: ID
    $name: String
    $description: String
    $associateUsers: [UserIdentifierInput!]
    $disassociateUsers: [UserIdentifierInput!]
    $associateClients: [OrganizationIdentifierInput!]
    $disassociateClients: [OrganizationIdentifierInput!]
    $associateSites: [SiteIdentifierInput!]
    $disassociateSites: [SiteIdentifierInput!]
    $techAutoAssignmentMethod: String
    $accessAllClients: Boolean
    $accessAllSites: Boolean
  ) {
    updateTechGroup(
      input: {
        groupId: $groupId
        name: $name
        description: $description
        associateUsers: $associateUsers
        disassociateUsers: $disassociateUsers
        associateClients: $associateClients
        associateSites: $associateSites
        disassociateClients: $disassociateClients
        disassociateSites: $disassociateSites
        techAutoAssignmentMethod: $techAutoAssignmentMethod
        accessAllClients: $accessAllClients
        accessAllSites: $accessAllSites
      }
    ) {
      groupId
      name
      description
      userList {
        userId
        firstName
        lastName
        email
      }
      techAutoAssignmentMethod
    }
  }
`;

const UPDATE_TECHGROUP_USERS = gql`
  mutation(
    $groupId: ID
    $associateUsers: [UserIdentifierInput!]
    $disassociateUsers: [UserIdentifierInput!]
  ) {
    updateTechGroupUsers(
      input: {
        groupId: $groupId
        associateUsers: $associateUsers
        disassociateUsers: $disassociateUsers
      }
    ) {
      groupId
      name
      description
    }
  }
`;

const UPDATE_TECHGROUP_CLIENTS = gql`
  mutation(
    $groupId: ID
    $roleType: RoleTypeInput
    $associateClients: [UserIdentifierInput!]
    $disassociateClients: [UserIdentifierInput!]
  ) {
    updateGroupClients(
      input: {
        groupId: $groupId
        roleType: $roleType
        associateClients: $associateClients
        disassociateClients: $disassociateClients
      }
    ) {
      groupId
      name
      description
    }
  }
`;

export {
  ADD_TECHGROUP,
  UPDATE_TECHGROUP,
  UPDATE_TECHGROUP_USERS,
  UPDATE_TECHGROUP_CLIENTS,
  DELETE_TECHGROUP
};
